var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1),_c('toast',{attrs:{"compromise":true}}),_c('loading'),_c('img-viewer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }